import { compiledClientConfig } from "config";

export const isDevelopment =
  compiledClientConfig.appEnv === "development" || compiledClientConfig.appEnv === "localhost";

export const devLog = (logOptions: {
  extra?: object;
  level?: "debug" | "error" | "info" | "warn";
  message: string;
}) => {
  if (!isDevelopment) return;
  const { extra, level = "info", message } = logOptions;
  switch (level) {
    case "debug":
      console.debug(message, extra);
      break;
    case "error":
      // no-dd-sa:typescript-best-practices/no-console
      console.error(message, extra);
      break;
    case "info":
      // no-dd-sa:typescript-best-practices/no-console
      console.info(message, extra);
      break;
    case "warn":
      // no-dd-sa:typescript-best-practices/no-console
      console.warn(message, extra);
      break;
    default:
      break;
  }
};
